export default ({ fontSize }) => ({
  label: {
    marginBottom: 5,
  },
  filterContainer: {
    height: '89%',
    display: 'block',
    position: 'relative',
    '& div > label': {
      margin: 10,
      fontSize: fontSize.medium,
    },
  },
  filterFooter: {
    paddingLeft: 20,
    borderTop: '1px solid #c8d1e0',
  },
});
